import { render, staticRenderFns } from "./SignaturePdf.vue?vue&type=template&id=cd8df9aa&"
import script from "../../../public/js/img/Discoveryjs/Signature/Signature.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/Signature/Signature.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports